import { useState, useEffect, useRef } from 'react';

export const useInputWidth = (isEditMode: boolean, innerValue: string) => {
	const fakeElRef = useRef<HTMLSpanElement>(null);
	const [inputWidth, setInputWidth] = useState<number>();

	useEffect(() => {
		fakeElRef.current && setInputWidth(fakeElRef.current.clientWidth);
	}, [isEditMode, innerValue]);

	return { inputWidth, fakeElRef };
};
